import type { SocialsProspectDefaults } from "@bluframe/mightychroma-mightytool-frontend-types"

import JobTriggerPanel from "./JobTriggerPanel"

export type JobTriggerKey = "discoveryIngest" | "followerSync"

export interface JobTriggerState {
  cooldownUntil?: Date | string | null
  disabledReason?: string | null
  errorMessage?: string | null
  isRunning: boolean
}

export interface JobTriggerCallbacks {
  onRunDiscoveryIngest: (keywordsOverride?: string[]) => void
  onRunFollowerSync: () => void
}

export interface Props extends JobTriggerCallbacks {
  discoveryIngest: JobTriggerState
  followerSync: JobTriggerState
  prospectDefaults: SocialsProspectDefaults | null
}

export interface ComponentProps extends Props {}

export default JobTriggerPanel
